import { recoilPersist } from 'recoil-persist';

/**
 * セッションストレージへ Recoil state を保存するための共通 effect。
 * SSR では `window` が存在しないため、クライアント実行時だけ sessionStorage を使う。
 */
const { persistAtom } = recoilPersist({
  key: 'recoil-persist',
  storage: typeof window === 'undefined' ? undefined : sessionStorage,
});

export default persistAtom;
